import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "card-selector" };
const _hoisted_2 = { class: "grid-wrapper grid-col-auto" };
const _hoisted_3 = ["for"];
const _hoisted_4 = ["value", "id", "disabled"];
const _hoisted_5 = { class: "card-content-wrapper" };
const _hoisted_6 = { class: "card-content" };
const _hoisted_7 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_field_block = _resolveComponent("g-field-block");
    return (_openBlock(), _createBlock(_component_g_field_block, _mergeProps(_ctx.$attrs, {
        name: _ctx.dataMember,
        "show-label": _ctx.showLabel,
        "error-message": _ctx.errorMessage,
        label: _ctx.label
    }), {
        "g-field-input": _withCtx(({ identification, error, disabled, size, setFocusClass, removeFocusClass, hasSuffix, hasPrefix }) => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                        return (_openBlock(), _createElementBlock("label", null, [
                            _createElementVNode("label", {
                                for: 'radio-card_' + item.name,
                                class: "radio-card"
                            }, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    name: "radio-card",
                                    value: item.name,
                                    id: 'radio-card_' + item.name,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.internalValue) = $event)),
                                    disabled: item.disabled
                                }, null, 8, _hoisted_4), [
                                    [_vModelRadio, _ctx.internalValue]
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "check-icon" }, null, -1)),
                                    _createElementVNode("div", _hoisted_6, [
                                        (item.image)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: item.image.src
                                            }, null, 8, _hoisted_7))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("h4", null, _toDisplayString(item.label), 1),
                                        _createElementVNode("h5", null, _toDisplayString(item.description), 1)
                                    ])
                                ])
                            ], 8, _hoisted_3)
                        ]));
                    }), 256))
                ])
            ])
        ]),
        _: 1
    }, 16, ["name", "show-label", "error-message", "label"]));
}
